import React from 'react';
import * as Styles from './NewMacroStep1.style';
import { StepLabel } from 'components/step-label/StepLabel';
import RadioButton from 'components/radio-button/RadioButton';
import FormikErrorMessage from 'components/formik-error-message/FormikErrorMessage';
import { H6 } from 'utils/resuable-css';

const NewMacroStep1 = ({ formikProp, edited }) => {
  const { values, setFieldValue } = formikProp;
  return (
    <Styles.NewMacroStep1SC>
      <StepLabel id="ST1" stepCount={'Step 1'}>
        {edited ? `Let's edit a macro; choose its language` : `Let's create a macro; choose its language`}
      </StepLabel>
      <Styles.SelectLanguage>
        <Styles.Lang onClick={() => setFieldValue('language', 'en')}>
          <RadioButton
            id="en"
            checkbox={values.language}
            setCheckedValue={(value) => setFieldValue('language', value)}
          />
          <H6>English</H6>
        </Styles.Lang>
        <Styles.Lang onClick={() => setFieldValue('language', 'es')}>
          <RadioButton
            id="es"
            checkbox={values.language}
            setCheckedValue={(value) => setFieldValue('language', value)}
          />
          <H6>Spanish</H6>
        </Styles.Lang>
      </Styles.SelectLanguage>
      <FormikErrorMessage formikProp={formikProp} value="language" />
    </Styles.NewMacroStep1SC>
  );
};
export default NewMacroStep1;
